import serialize from 'form-serialize';

import $ from '../core/Dom';
import Components from '../core/Components';
import Dispatch from '../core/Dispatch';
import superagent from '../core/request';

import { SHOW_FLASH_MESSAGE, CART_UPDATED } from '../lib/events';
import loginForm from "./LoginForm";

export default (el, props) => {
    const $el = $(el);
    const $loadingOverlay = $el.find('[data-loading-overlay]');

    const { reloadUrl } = props;
    let isSubmitting = false;

    const trackView = () => {
        const $cartItems = $el.find('[data-cart-item]');
        const itemsMerged = [];
        const items = [];
        let value = 0;

        $cartItems.each(item => {
            const $cartItem = $(item);
            const productData = $cartItem.data('cart-item');
            const productTrackingData = productData.productTrackingData || null;
            
            if (productTrackingData !== null) {
                if (itemsMerged[productTrackingData.item_id] === undefined) {
                    itemsMerged[productTrackingData.item_id] = productTrackingData;
                } else {
                    itemsMerged[productTrackingData.item_id].quantity += productTrackingData.quantity;
                }
            }
        });

        itemsMerged.forEach((el, index) => {
            el.index = index;
            value += el.price * el.quantity;
            items.push(el);
        });

        value = Math.round(value * 100) / 100;

        const ecommerceData = {
            currency: 'NOK',
            value,
            items
        };

        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: 'view_cart',
            ecommerce: ecommerceData
        });
    };

    const trackChangeQty = ($qtySelect, isRemove) => {
        const $cartItem = $qtySelect.closest('[data-cart-item]');
        const productData = $cartItem.data('cart-item');
        const productTrackingData = productData.productTrackingData || null;
        let event = 'remove_from_cart';

        if (productTrackingData !== null) {
            if (!isRemove) {
                const qty = parseInt($qtySelect.val(), 10);
                const oldQty = parseInt($qtySelect.data('current-qty'), 10);
                const diff = qty - oldQty;
                $qtySelect.data('current-qty', qty);
                productTrackingData.quantity = qty;
                if (diff > 0) {
                    event = 'add_to_cart';
                }
            }

            const ecommerceData = {
                currency: 'NOK',
                value: productTrackingData.price * productTrackingData.quantity,
                items: [productTrackingData]
            };

            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event,
                ecommerce: ecommerceData
            });
        }
    };

    const injectNewMarkup = html => {
        const $html = $(`<div>${html}</div>`);
        const $ajaxWrap = $html.find('[data-ajax-wrapper]');
        const $newData = $html.find('[data-component="CartForm"]').eq(0);

        const opts = $ajaxWrap.data('ajax-wrapper');

        if (opts.flashMessage !== undefined && opts.flashMessage !== '' && opts.isError) {
            Dispatch.emit(SHOW_FLASH_MESSAGE, { message: opts.flashMessage, isError: opts.isError });
        }

        Components.destroy(el.children);
        $el.html($newData.html());
        Components.init(el);
    };

    const loadData = () => {
        superagent.get(`/${reloadUrl}`).then(res => {
            if (!res) {
                return;
            }
            const { status, text: html } = res;
            if (status !== 200) {
                throw new Error();
            }

            injectNewMarkup(html);
        }).catch(error => {
            console.error({ error });
            Dispatch.emit(SHOW_FLASH_MESSAGE, { message: 'En feil oppstod, vennligst prøv på nytt!', isError: true });
        }).then(() => {
            isSubmitting = false;
        });
    };

    const submit = () => {
        if (isSubmitting) {
            return;
        }

        isSubmitting = true;
        $el.addClass('is-submitting');

        const data = serialize($el.get(0), { hash: false });

        // POST the request
        superagent.post(window.location.href).accept('application/json').send(data).then(res => {
            const { status, body } = res || {};

            if (status === 200 && body) {
                if (body.success === true) {
                    loadData();

                    Dispatch.emit(CART_UPDATED, {
                        cart: body.cart
                    });
                } else {
                    Dispatch.emit(SHOW_FLASH_MESSAGE, { message: 'En feil oppstod, vennligst prøv på nytt!', isError: true });
                }
            } else {
                Dispatch.emit(SHOW_FLASH_MESSAGE, { message: 'En feil oppstod, vennligst prøv på nytt!', isError: true });
            }

            return null;
        }).catch(error => {
            console.error({ error });
            Dispatch.emit(SHOW_FLASH_MESSAGE, { message: 'En feil oppstod, vennligst prøv på nytt!', isError: true });
        }).then(() => {
            isSubmitting = false;
            $el.removeClass('is-submitting');
        });
    };

    const init = () => {
        $el.on('click', '[data-remove-lineitem]', e => {
            const $button = $(e.triggerTarget);
            const targetId = $button.data('remove-lineitem');
            const $input = $el.find(`#${targetId}`);
            trackChangeQty($(e.triggerTarget), true);

            if ($input.length > 0) {
                $input.val('1');
                submit();
            }
        });

        $el.on('change', '[data-qty-select]', e => {
            trackChangeQty($(e.triggerTarget), false);
            submit();
        });

        $el.on('submit', e => {
            e.preventDefault();
            submit();
        });

        trackView();
    };

    const destroy = () => {

    };

    return {
        init,
        destroy
    };
};
